module.exports = __webpack_public_path__ + "media/level_up.fbbc31a2.mp3";